<template>
  <div>
    <b-modal
      id="trackWidget"
      ref="trackWidget"
      hide-header
      hide-footer
      modal-class="modal-dialog track-widget-modal"
      ignore-enforce-focus-selector=".webim-root"
      v-if="isModal"
    >
      <TrackingWidget
        :isModal="isModal"
        :initialTrackNumber="initialTrackNumber"
      ></TrackingWidget>
    </b-modal>
    <TrackingWidget
      v-else
      :isModal="isModal"
      :initialTrackNumber="initialTrackNumber"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
import TrackingWidget from './TrackingWidget.vue';


const trackWidgetModal = {
  name: 'TrackWidgetWrap',
  components: {
    TrackingWidget,
  },
  mounted() {
    if (this.isModal) {
      this.$bvModal.show('trackWidget');
    }
  },
};

const factory = function (options) {
  const opts = _.extend({
    // Open as modal
    isModal: true,
    // Element to mount in
    el: null,
    initialTrackNumber: '',
  }, options);

  let $trackWidgetContainer;

  if (!opts.el) {
    $trackWidgetContainer = document.createElement('div');
    $trackWidgetContainer.setAttribute('id', 'formbar-tracking-popup');
    document.body.appendChild($trackWidgetContainer);
  } else {
    $trackWidgetContainer = opts.el;
  }

  const instance = new Vue({
    ...trackWidgetModal,
    data() {
      return {
        isModal: opts.isModal,
        initialTrackNumber: opts.initialTrackNumber,
      };
    },
  });

  instance.$mount($trackWidgetContainer);

  return instance;
};

/**
 * Слушает событие startSearchTrack и по событию создает экземлпяр виджета и запускает поиск
 */
const listenToStartSearchTrackEvent = function (options) {
  document.addEventListener('startSearchTrack', (e) => {
    const opts = _.extend({}, options, {
      initialTrackNumber: e.detail.track,
    });

    factory(opts);
  });
};

export { trackWidgetModal as default, factory, listenToStartSearchTrackEvent };
</script>

<style lang="scss" scoped>

  .track-widget-modal {

    .track-widget__header {

      .formbar-fields_track-widget {
        margin-top: 0;
      }
    }
  }

</style>
